



















































































import Vue from "vue";
import { Form } from "element-ui";
import { axios } from "@/plugins";
import { mapGetters } from "vuex";

const RuleForm = {
  description: "",
  name: "",
  secret: "",
  targetType: "DINGTALK",
  targetUrl: "",
  tenantCode: ""
};
const TargetTypeOption = [
  {
    label: "钉钉",
    value: "DINGTALK"
  }
  // 为实现功能
  // {
  //   label: "邮箱",
  //   value: "EMAIL"
  // },
  // {
  //   label: "短信",
  //   value: "SMS"
  // }
];
export default Vue.extend({
  name: "Edit",
  data() {
    return {
      isEdit: false,
      dialog: false,
      loading: false,
      form: { ...RuleForm },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        targetType: [
          { required: true, message: "请输入名称", trigger: "change" }
        ],
        targetUrl: [
          { required: true, message: "请输入Webhook地址", trigger: "blur" }
        ],
        secret: [{ required: true, message: "请输入密钥", trigger: "blur" }]
      },
      TargetTypeOption
    };
  },
  computed: {
    ...mapGetters("LoginInfo", ["tenant"]),

    header() {
      // @ts-ignore
      return this.isEdit ? "编辑告警目标" : "创建告警目标";
    }
  },
  methods: {
    show(data: any) {
      if (data) {
        // @ts-ignore
        this.isEdit = true;
        // @ts-ignore
        this.form = { ...data };
      } else {
        // @ts-ignore
        this.form.tenantCode = this.tenant.code;
      }
      // @ts-ignore
      this.dialog = true;
    },
    quit() {
      // @ts-ignore
      this.dialog = false;
      setTimeout(() => {
        // @ts-ignore
        this.form = { ...RuleForm };
        (this.$refs.form as Form).resetFields();
        // @ts-ignore
        this.isEdit = false;
      }, 200);
    },
    submit() {
      (this.$refs.form as any).validate((valid: any) => {
        if (valid) {
          // @ts-ignore
          this.loading = true;
          // @ts-ignore
          if (this.isEdit) {
            // @ts-ignore
            this.edit();
          } else {
            // @ts-ignore
            this.create();
          }
        }
      });
    },
    create() {
      axios
        // @ts-ignore
        .post(`/alerttarget/${this.tenantId}`, this.form)
        .then(() => {
          this.$message.success("告警目标创建成功");
          // @ts-ignore
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          // @ts-ignore
          this.loading = false;
        });
    },
    edit() {
      axios
        // @ts-ignore
        .put(`/alerttarget/${this.tenantId}`, this.form)
        .then(() => {
          this.$message.success("告警目标修改完成");
          // @ts-ignore
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          // @ts-ignore
          this.loading = false;
        });
    }
  }
});
